module.exports = __webpack_public_path__ + "img/inread_banner.179d079d.jpg";